import React from "react";
import PropTypes from "prop-types";
import Days from "./days";
import CircaApi from "../../../lib/api/circaApi";
import Months from "./months";
import Slots from "./slots";
import moment from "moment/moment";
import Loader from "../../loaderAnimated";
import styled from "styled-components";

const NoSlots = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
    min-width: 330px;
    align-items: center;
    padding: 25px 0;
    box-sizing: border-box;
`;

class Calendar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            state: 'empty', // loading // active
            slots: null,
            days: [],
            officeId: props.officeId,
            currentDay: null,
            currentMonth: null,
            currentYear: null,
            currentSlot: null,
        };
    }

    componentDidMount() {
        if (this.state.slots === null){
            this.loadSlots();
        }
    }

    componentDidUpdate() {
        if(this.state.state === 'loading'){
            return;
        }

        if (this.state.officeId === this.props.officeId ){
           return;
        }

        this.setState({
            slots: null,
            days: [],
            officeId: this.props.officeId,
            currentDay: null,
            currentMonth: null,
            currentYear: null,
            currentSlot: null
        });

        this.loadSlots();
    }

    loadSlots (){
        this.setState({ state: 'loading' });

        const dateFrom = moment().startOf('month').format('YYYY-MM-DD');
        const dateTo= moment().add(1, 'month').endOf('month').format('YYYY-MM-DD');

        CircaApi.getSlots(dateFrom, dateTo, this.props.officeId).then(result => {
            const slots = this.prepareSlotsData(result);
            this.setState({ slots: slots, state: slots.length === 0 ? 'empty' : 'active', officeId: this.props.officeId});

        }).catch(error => {
            console.log('something wrong with data loading', error);
            this.setState({ slots: null, state: 'active', officeId: this.props.officeId});
        });
    }

    prepareSlotsData(data){
        return Object.keys(data).map(day => {
            return {
                key: day,
                date: moment(day),
                slots: data[day].map(slot =>  moment(slot, 'HH:mm') )
            };
        });
    }

    setSlot(slot, dateTime){
        this.setState({ currentSlot: slot});
        this.props.setDateTime(dateTime);
    }

    setDay(day){
        this.setSlot(null);
        this.setState({currentDay: day});
    }

    setMonth(month){
        this.setState({ currentMonth: month});
    }

    render() {
        if(this.state.state === 'loading') {
            return (
                <div className="calendar-container">
                    <Loader> </Loader>
                </div>
            )
        }

        if(this.state.state === 'empty') {
            return (
                <div className="calendar-container">
                    <NoSlots>
                        There are no available time slots for the current period
                    </NoSlots>
                </div>
            )
        }

        return (
            <div className="calendar-container">
                <div className="calendar">
                    <Months
                        slots={this.state.slots}
                        setMonth={this.setMonth.bind(this)}
                        currentMonth={this.state.currentMonth}
                    />

                    <Days
                        slots={this.state.slots}
                        setDay={this.setDay.bind(this)}
                        currentDay={this.state.currentDay}
                        currentMonth={this.state.currentMonth}
                    />

                    <Slots
                        slots={this.state.slots}
                        setSlot={this.setSlot.bind(this)}
                        currentDay={this.state.currentDay}
                        currentSlot={this.state.currentSlot}
                    />

                </div>
            </div>
        )
    }
}

Calendar.propTypes = {
    officeId: PropTypes.number.isRequired,
    slots: PropTypes.objectOf(PropTypes.any),
    setDateTime: PropTypes.func.isRequired
};

export default Calendar;
